'use client';

import { StyleProvider, createCache } from '@ant-design/cssinjs';
import { useServerInsertedHTML } from 'next/navigation';
import type React from 'react';
import { Fragment, useState } from 'react';

export default function AntdRegistry({ children }: { children: React.ReactNode }) {
    const [cache] = useState(() => createCache());

    useServerInsertedHTML(() => (
        <Fragment>
            <style id='antd' />
        </Fragment>
    ));

    return (
        <StyleProvider cache={cache} hashPriority='high'>
            {children}
        </StyleProvider>
    );
}
